var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#28D748"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.821 16.9101C21.72 14.1451 27.289 14.3711 30.894 17.4451C34.561 20.5741 35.062 25.6831 32.046 29.3431C29.205 32.7901 24.081 33.9261 19.815 32.1481L19.582 32.0471L15.208 32.9781L15.168 32.9841L15.133 32.9911H15.115L15.093 32.9961H15.055L15.022 33.0001L15.001 32.9991L14.978 33.0001L14.945 32.9971H14.91L14.888 32.9931L14.866 32.9911L14.831 32.9841L14.797 32.9791L14.781 32.9751L14.757 32.9701L14.708 32.9541L14.684 32.9491L14.673 32.9441L14.651 32.9371L14.606 32.9171L14.576 32.9051L14.565 32.8991L14.551 32.8931L14.52 32.8751L14.475 32.8511L14.459 32.8401L14.422 32.8141L14.382 32.7871L14.38 32.7831L14.367 32.7741L14.324 32.7341L14.299 32.7141L14.293 32.7071L14.237 32.6451L14.224 32.6311L14.213 32.6171L14.174 32.5611L14.16 32.5421L14.155 32.5321L14.113 32.4591L14.106 32.4471L14.102 32.4391L14.095 32.4271L14.081 32.3891L14.061 32.3471L14.057 32.3311L14.053 32.3211L14.036 32.2601L14.029 32.2421L14.027 32.2271L14.022 32.2081L14.017 32.1751L14.009 32.1331L14.007 32.1021L14.004 32.0921V32.0761L14 32.0221L14.001 31.9861L14.002 31.9631L14.004 31.9101L14.008 31.8851V31.8661L14.016 31.8311L14.021 31.7971L14.026 31.7771L14.03 31.7571L14.048 31.6971L14.051 31.6841L15.201 28.2341L15.179 28.1971C12.969 24.4501 13.97 19.8061 17.592 17.0781L17.821 16.9101Z",
    fill: "#DFEAD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatAppIcon);
export default __webpack_public_path__ + "static/media/chatAppIcon.fd7eb316a57fff3d6c8819044a34adf1.svg";
export { ForwardRef as ReactComponent };